<div class="grid grid-2col gap p-2">
    <app-select-input
        id="type"
        [form]="form"
        [prefix]="prefix"
        [staticOptions]="typeOptions"
        [disabled]="form.value.id"
    ></app-select-input>
    <app-date-input
        id="date"
        [form]="form"
        [prefix]="prefix"
    ></app-date-input>
</div>
<div class="grid grid-2col gap p-2">
    <app-number-input
        id="amount"
        [form]="form"
        [prefix]="prefix"
        [min]="0"
    ></app-number-input>
    @if (form.value.type !== WarehouseMaterialOperationTypeEnum.RECEIPT) {
        <app-select-input 
            id="folderId" 
            [form]="form" 
            [label]="prefix + 'fields.folderId'"
            [infiniteScroll]="foldersScroll()"
            filterBy="name,surname,email,id"
            valueKey="id"
            [showClear]="true"
        >
            <ng-template #item let-item>
                {{ item.person | formatPerson }}
            </ng-template>
            <ng-template #selectedItem let-item>
                {{ item.person | formatPerson }}
            </ng-template>
        </app-select-input>
    }
</div>
<div class="grid p-2 grid-1col gap-2">
    <app-input-user-multiselect 
        id="workerIds"
        [form]="form" 
        [label]="prefix + 'fields.workers'"
        [serviceId]="serviceId()"
        [employment]="EmploymentParentGroupEnum.DIRECT_CARE"
    ></app-input-user-multiselect>
    <app-text-area-input
        id="description"
        [form]="form"
        [prefix]="prefix"
    ></app-text-area-input>
</div>
